/* ============================================================================
   c111-render-config-run.js  ·  111 Cientonce · 26 ago 2026
   AÑADIDO de running. Se carga DESPUÉS de c111-render-config.js y le agrega
   referencias nuevas sin tocar ese archivo.
   ---------------------------------------------------------------------------
   POR QUÉ ESTÁ APARTE

     · MANGA LARGA -> "pongamos una manga corta porque es lo mismo".
       No lleva referencia propia: el camibuso cae en run-tee-h / run-tee-m,
       que es el mismo torso. Eso además resuelve el problema de medida: en un
       render de manga larga no se puede medir el ancho del cuerpo sin
       confundirlo con las mangas.

     · CROP TOP -> "dejemos solo la parte de adelante". Por eso back:null,
       aunque los renders de espalda existan.

     · ESPALDA DE CAMISETA (26 ago, tarde) -> Nicolás subió Tee_back_wt,
       Tee_back_grey y Tee_back_bk. Con eso la camiseta deja de ser solo
       frente: 48 prendas de running ganan la pestaña de espalda.

   OJO CON LA MEDIDA DEL CROP TOP
   La guía de tallas NO tiene tabla de crop top ni de top deportivo. Se usa el
   pecho de la CAMISILLA MUJER (40 cm de sisa a sisa en talla M), que es la
   medida oficial más cercana. Está marcado como aproximación a propósito — si
   Felipe pasa la medida real del crop top, se cambia el 40 de abajo y ya.

   La franja del cuerpo se midió sobre croptopbrezzafrente: entre las mangas y
   el ruedo la prenda ocupa el 57,5% del ancho de la imagen, del 21% al 79%.

   ---------------------------------------------------------------------------
   CÓMO SE MIDIÓ LA ESPALDA DE CAMISETA (Tee_back_*.png)
   Archivos de 2000x2000, fondo transparente, una sola prenda centrada.
   Medido sobre el render: la prenda va de x=16,8% a x=83,0% (eso incluye las
   mangas) y de y=11,5% a y=93,2%. Las mangas terminan al 40% del alto de la
   prenda; de ahí para abajo queda el cuerpo, que ocupa el 36,7% del ancho de
   la imagen. Ese 0.367 es el anchoFrac: de sisa a sisa.
   Comprobación: cuerpo/alto da 0,449 en la espalda y 0,466 en el frente
   genérico — es la misma prenda, solo que la espalda viene más lejos en el
   cuadro. Por eso su frameCm es mayor (140 vs 110) y aun así un aplique de
   12 cm mide 12 cm reales en las dos caras.

   La zona va de y=50 a y=82 (debajo del canesú y encima del ruedo) y de x=35
   a x=65, dejando ~5 cm de margen contra cada costura.
   ========================================================================== */
(function(){
'use strict';
var C = window.C111render;
if (!C || !C.RENDERS) return;

var R = 'https://cdn.shopify.com/s/files/1/0254/8665/5591/files/';

function vistaCm(img, ratio, anchoFrac, prendaCm, zoom, zonas){
  return { img:img, ratio:ratio, zoom:zoom||1,
           frameCm:+(prendaCm/anchoFrac).toFixed(0), zonas:zonas, zip:null };
}
var Z = function(k,l,x1,y1,x2,y2,cap){ return {k:k,l:l,x1:x1,y1:y1,x2:x2,y2:y2,cap:cap}; };

/* ---------------------------- CROP TOP ---------------------------------- */
var cropF = vistaCm(R+'croptopbrezzafrente.png?v=1787693027', 1.2, 0.575, 40, 1,
              [ Z('torso','Torso', 33,58,67,76,12) ]);

C.RENDERS['run-crop'] = { front: cropF, back: null };
C.VR = C.VR || {};
C.VR.cropF = cropF;

/* ------------------- ESPALDA GENÉRICA DE CAMISETA ------------------------ */
var TEE_E = {
  blanco: R+'Tee_back_wt.png?v=1787773803',
  gris  : R+'Tee_back_grey.png?v=1787773793',
  negro : R+'Tee_back_bk.png?v=1787773784'
};

/* mismo recorte para las tres: son el mismo archivo en tres colores */
var ZE_H = [ Z('espalda','Espalda', 35,50,65,82,24) ];
var ZE_M = [ Z('espalda','Espalda', 35,50,65,82,20) ];

function espaldaTee(url, cm, zonas){
  return vistaCm(url, 1, 0.367, cm, 1, zonas);
}

var teeE = {
  hBlanco: espaldaTee(TEE_E.blanco, 51.5, ZE_H),
  hGris  : espaldaTee(TEE_E.gris,   51.5, ZE_H),
  hNegro : espaldaTee(TEE_E.negro,  51.5, ZE_H),
  mBlanco: espaldaTee(TEE_E.blanco, 46.5, ZE_M),
  mGris  : espaldaTee(TEE_E.gris,   46.5, ZE_M),
  mNegro : espaldaTee(TEE_E.negro,  46.5, ZE_M)
};

/* El FRENTE genérico no cambia: sigue siendo el mismo de c111-render-config.js.
   En la práctica casi nunca se ve, porque el frente lo pone el render real del
   producto; queda solo como respaldo si una foto no se puede medir. */
var frenteH = C.VR && C.VR.teeH_F ? C.VR.teeH_F : null;
var frenteM = C.VR && C.VR.teeM_F ? C.VR.teeM_F : null;

C.RENDERS['run-tee-h']       = { front: frenteH, back: teeE.hBlanco };
C.RENDERS['run-tee-h-gris']  = { front: frenteH, back: teeE.hGris  };
C.RENDERS['run-tee-h-negro'] = { front: frenteH, back: teeE.hNegro };
C.RENDERS['run-tee-m']       = { front: frenteM, back: teeE.mBlanco };
C.RENDERS['run-tee-m-gris']  = { front: frenteM, back: teeE.mGris  };
C.RENDERS['run-tee-m-negro'] = { front: frenteM, back: teeE.mNegro };

C.VR.teeE = teeE;
})();